import { api } from "api/api";
import { AxiosError } from "axios";
import FamiliaProduto from "model/administracao/cadastro/produto/FamiliaProduto";
import OrigemProduto from "model/administracao/cadastro/produto/OrigemProduto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";

class FamiliaProdutoService implements BaseServiceCadastros<FamiliaProduto> {

    getFilters(filter: DataTableFilterMeta | null): string {
        
        let filters = '?filters=';
        if(filter){
            Object.keys(filter).forEach((key, index) => {
                if(key === 'null') return
                let filterField = filter[key] as DataTableOperatorFilterMetaData;
                filters += encodeURIComponent(index>0 ? ',' : '{');
                filters += encodeURIComponent(`"${key}":{"value":"${filterField.constraints[0].value || ''}"`);
                filters += encodeURIComponent(`,"type":"${filterField.constraints[0].matchMode?.toUpperCase()}"}`);
            });
            if(filters.length>9){
                filters += encodeURIComponent('}');
            }
        }
        
        return filters;
    }

    pesquisar(page: Pageable, filter?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/familia/pesquisar`;
            if(filter){
                url+=this.getFilters(filter)
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: string | number) {
        return new Promise<FamiliaProduto>((resolve, reject): void => {
            api
                .get(`/familia/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(familia: FamiliaProduto) {
        return new Promise<FamiliaProduto>((resolve, reject): void => {
            let url = `/familia/incluir`;
            api
                .post(url, JSON.stringify(familia))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(familia: FamiliaProduto) {
        return new Promise<FamiliaProduto>((resolve, reject): void => {
            api
                .put(`/familia/editar`, JSON.stringify(familia))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: string | number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/familia/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    origens() {
        return new Promise<Array<OrigemProduto>>((resolve, reject): void => {
            api
                .get(`/familia/origens`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    proximoCodigo(){
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/familia/proximoCodigo`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default FamiliaProdutoService;
